/** Substrings seen across browsers/bundlers for a failed dynamic chunk load. */
const CHUNK_LOAD_ERROR_PATTERNS = [
	'Failed to fetch dynamically imported module', // Chromium
	'error loading dynamically imported module', // Firefox
	'Importing a module script failed', // Safari / WebKit
	'Unable to preload CSS', // Vite preload helper (CSS dep)
	'Loading chunk', // legacy webpack wording (defensive)
	'ChunkLoadError', // legacy webpack error name (defensive)
]

/** True when an error looks like a failed dynamic chunk load (vs. a real application error). */
export function isChunkLoadError(error: unknown): boolean {
	const message = (error instanceof Error ? error.message : String(error ?? '')) || ''
	const name = error instanceof Error ? error.name : ''
	return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => message.includes(pattern) || name.includes(pattern))
}
